export const HOST = "HOST";
export const USER_NO = "USER_NO";
export const USER_NAME = "USER_NAME";
export const LEVEL_CODE = "LEVEL_CODE";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const IS_AUTH = "IS_AUTH";
export const LOGIN_INFO = "LOGIN_INFO";
